import { createSelector } from '@reduxjs/toolkit';

import { selectLanguage } from './i18n.selectors';
import { selectSelectedSite, selectUserJobname, selectUserUID } from './userInfo';

export const selectGtmUserArgs = createSelector(
  [selectUserJobname, selectUserUID, selectLanguage, selectSelectedSite],
  (userJobname, userUID, languageCode, selectedSite) => ({
    userJobname,
    userUID,
    languageCode,
    selectedSite,
  })
);
